import { render } from "./MenuLink.vue?vue&type=template&id=efd035dc&scoped=true"
import script from "./MenuLink.vue?vue&type=script&lang=js"
export * from "./MenuLink.vue?vue&type=script&lang=js"

import "./MenuLink.vue?vue&type=style&index=0&id=efd035dc&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efd035dc"]])

export default __exports__